var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"textarea",staticClass:"rounded",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){_vm.resize(); _vm.$emit('input', $event.target.value);}}})
}
var staticRenderFns = []

export { render, staticRenderFns }